import {NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';

import { BerakningshjalpenRoutingModule } from './berakningshjalpen-routing.module';
import { BerakningshjalpenComponent } from './berakningshjalpen.component';
import { CoreModule } from '../core/core.module';
import { FormComponent } from './components/dina-uppgifter/form/form.component';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { TableComponent } from './components/dina-uppgifter/table/table.component';
import { DinaUppgifterService } from './services/dina-uppgifter.service';
import { DinaUppgifterPageComponent } from './pages/dina-uppgifter/dina-uppgifter';
import { ResultatPageComponent } from './pages/resultat/resultat.page';
import { MobileStateService } from './services/mobile/mobile-state.service';
import { DateService } from './services/date/date.service';
import { CardInfoComponent } from './shared/cards/card-info/card-info.component';
import { InformationTextComponent } from './components/dina-uppgifter/information-text/information-text.component';
import { FormSelectComponent } from './shared/form/form-select/form-select.component';
import { FormRadioComponent } from './shared/form/form-radio/form-radio.component';
import { FormRowComponent } from './shared/form/form-row/form-row.component';
import { FormDateComponent } from './shared/form/form-date/form-date.component';
import { FormCurrencyComponent } from './shared/form/form-currency/form-currency.component';
import { ThousandSeparatorDirective } from './shared/directives/thousand-separator.directive';
import { NumberDirective } from './shared/directives/number.directive';
import { ModalAlertComponent } from './shared/modals/modal-alert/modal-alert.component';
import { MobileTableComponent } from './components/dina-uppgifter/mobile-table/mobile-table.component';
import { MobileTableItemComponent } from './components/dina-uppgifter/mobile-table/mobile-table-item/mobile-table-item.component';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { ModalTableAlertComponent } from './shared/modals/modal-table-alert/modal-table-alert.component';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { ButtonCollapsComponent } from './shared/buttons/button-collaps/button-collaps.component';
import { ResultatSummaComponent } from './components/resultat/resultat-summa/resultat-summa.component';
// eslint-disable-next-line max-len
import { ResultatAterbetalningsbeloppComponent } from './components/resultat/resultat-aterbetalningsbelopp/resultat-aterbetalningsbelopp.component';
import { ResultatTableComponent } from './components/resultat/resultat-table/resultat-table.component';
import { ResultatTableItemComponent } from './components/resultat/resultat-table-item/resultat-table-item.component';
import { ResultatDetailsComponent } from './components/resultat/resultat-details/resultat-details.component';
import { ResultatMobileTableComponent } from './components/resultat/resultat-mobile-table/resultat-mobile-table.component';
// eslint-disable-next-line max-len
import { ResultatMobileCollapseResultatDetailsComponent } from './components/resultat/resultat-mobile-collapse-resultat-details/resultat-mobile-collapse-resultat-details.component';
import { ModalServiceErrorComponent } from './shared/modals/modal-service-error/modal-service-error.component';
import { ModalFocusDirective } from './shared/directives/modal-focus.directive';
import { WhiteOverlaySpinnerComponent } from './shared/spinners/white-overlay-spinner/white-overlay-spinner.component';
import { ButtonPrintComponent } from './shared/buttons/button-print/button-print.component';
import { ModalConfirmComponent } from './shared/modals/modal-confirm/modal-confirm.component';
import { AccordionPrimaryComponent } from './shared/accordions/accordion-primary/accordion-primary.component';
import { AccordionSecondaryComponent } from './shared/accordions/accordion-secondary/accordion-secondary.component';
import { CardErrorComponent } from './shared/cards/card-error/card-error.component';
import { CardTechnicalErrorComponent } from './shared/cards/card-technical-error/card-technical-error.component';
import { CardWarningComponent } from './shared/cards/card-warning/card-warning.component';


@NgModule({
    declarations: [
        BerakningshjalpenComponent,
        FormComponent,
        TableComponent,
        DinaUppgifterPageComponent,
        ResultatPageComponent,
        CardInfoComponent,
        CardErrorComponent,
        InformationTextComponent,
        FormSelectComponent,
        FormRadioComponent,
        FormRowComponent,
        FormDateComponent,
        FormCurrencyComponent,
        ThousandSeparatorDirective,
        NumberDirective,
        ModalFocusDirective,
        ModalAlertComponent,
        MobileTableComponent,
        MobileTableItemComponent,
        ModalTableAlertComponent,
        ButtonCollapsComponent,
        ResultatSummaComponent,
        ResultatAterbetalningsbeloppComponent,
        ResultatTableComponent,
        ResultatTableItemComponent,
        ResultatDetailsComponent,
        ResultatMobileTableComponent,
        ResultatMobileCollapseResultatDetailsComponent,
        ModalServiceErrorComponent,
        WhiteOverlaySpinnerComponent,
        ButtonPrintComponent,
        ModalConfirmComponent,
        AccordionPrimaryComponent,
        AccordionSecondaryComponent,
        CardTechnicalErrorComponent,
        CardWarningComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        BerakningshjalpenRoutingModule,
        ReactiveFormsModule,
        PaginationModule.forRoot(),
        CollapseModule.forRoot(), // Move to bootstrap module
    ],
    exports: [
        BerakningshjalpenComponent,
        DinaUppgifterPageComponent,
        ResultatPageComponent
    ],
    providers: [
        DinaUppgifterService,
        MobileStateService,
        DateService,
        DecimalPipe
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class BerakningshjalpenModule { }
